module.exports = __webpack_public_path__ + "static/media/Male 1_1607025117888.0cb75e82.png";